import { DatePipe } from '@angular/common';
import { Inject, Injectable, InjectionToken, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

export const TIMEZONE = new InjectionToken<string>('TIMEZONE');
@Injectable({ providedIn: 'any' })
@Pipe({ name: 'date' })
export class CxbDatePipe extends DatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) locale: string, @Inject(TIMEZONE) public readonly timezone: string) {
    super(locale);
  }

  public transform(value: any, format?: string, timezone: string = this.timezone, locale?: string): any {
    return super.transform(value, format, timezone, locale);
  }
}
